export function initArticle(){
    const articleSelector = ".content-article";
    const sidebarSelector = ".sidebar-menu__items-article";
    const headerSelector = "header";
    const sidebarBlockSelector = ".main-sidebar";

    const article = document.querySelector(articleSelector);
    const sidebarList = document.querySelector(sidebarSelector);

    if (!article || !sidebarList) return;

    const headings: NodeListOf<HTMLHeadingElement> = article.querySelectorAll("h2");

    function translit(str: string): string {
        const map: Record<string, string> = {
            а: "a", б: "b", в: "v", г: "g", д: "d",
            е: "e", ё: "yo", ж: "zh", з: "z", и: "i",
            й: "y", к: "k", л: "l", м: "m", н: "n",
            о: "o", п: "p", р: "r", с: "s", т: "t",
            у: "u", ф: "f", х: "h", ц: "ts", ч: "ch",
            ш: "sh", щ: "sch", ъ: "", ы: "y", ь: "",
            э: "e", ю: "yu", я: "ya"
        };
        return str.toLowerCase()
            .split("")
            .map(ch => map[ch] ?? ch) // заменяем буквы
            .join("")
            .replace(/[^\w]+/g, "-") // всё лишнее → "-"
            .replace(/^-+|-+$/g, ""); // обрезаем лишние "-"
    }

    // Генерация id для h2
    headings.forEach((h2, index) => {
        const text = h2.textContent?.trim() ?? "";
        let slug = translit(text);
        if (!slug) slug = `section-${index + 1}`;
        h2.id = slug;
    });

    // Формируем список меню
    sidebarList.innerHTML = "";
    headings.forEach(h2 => {
        const li = document.createElement("li");
        li.className = "sidebar-menu__item";

        li.innerHTML = `
      <a href="#${h2.id}" class="sidebar-menu__link">
        <span class="sidebar-menu__link-ent">
          ${h2.textContent}
          <span class="icon">
            <svg><use xlink:href="images/sprite.svg#icon-arrow-right"></use></svg>
          </span>
        </span>
      </a>
    `;
        sidebarList.appendChild(li);
    });

    const links: NodeListOf<HTMLAnchorElement> = sidebarList.querySelectorAll("a");

    // Функция для вычисления отступа
    function getHeaderOffset(): number {
        const header = document.querySelector(headerSelector) as HTMLElement | null;
        const sidebarBlock = document.querySelector(sidebarBlockSelector) as HTMLElement | null;

        let offset = header?.offsetHeight ?? 0;

        if (window.innerWidth < 1140 && sidebarBlock) {
            offset += sidebarBlock.offsetHeight;
        }

        return offset;
    }

    // Плавный скролл по клику
    links.forEach(link => {
        link.addEventListener("click", e => {
            e.preventDefault();
            const id = link.getAttribute("href")?.substring(1);
            if (!id) return;

            const target = document.getElementById(id);
            if (!target) return;

            const offset = getHeaderOffset();
            const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({ top: y, behavior: "smooth" });
        });
    });

    // Подсветка активного пункта при скролле
    window.addEventListener("scroll", () => {
        const offset = getHeaderOffset();
        let currentId = "";

        headings.forEach(section => {
            const sectionTop = section.offsetTop - offset - 20;
            if (window.scrollY >= sectionTop) {
                currentId = section.id;
            }
        });

        links.forEach(link => {
            link.classList.toggle("active", link.getAttribute("href") === `#${currentId}`);
        });
    });
}